import React, {Component} from "react"
import {Route, Redirect} from "react-router-dom"

import {ContextRoute, Bundle} from "@irati/utils/history/routing"
import RegionProvider from "@irati/region/components/Provider"

import Platform from "@irati-web/platform/src/routes/global"
import GlobalStream from "@irati/auth/streams/global"

import APPS, {PLATFORM} from "../routeConfig"
import Providers from "../Providers"
import AuthProvider from "../AuthProvider"

export default class InternalRoutes extends Component {
  render() {
    return (
      <Providers>
        <RegionProvider>
          <AuthProvider authed={GlobalStream} unauthed={GlobalStream}>
            <Bundle>
              <ContextRoute app={PLATFORM} apps={APPS} routes={Platform} />
              <Route exact path="/" component={() => <Redirect to="/welcome/login" />} />
            </Bundle>
          </AuthProvider>
        </RegionProvider>
      </Providers>
    )
  }
}
